<template>
  <v-container class="pa-3 text-center">
    <h2>
      {{ voucher.Libelle }}
    </h2>
    <img
      v-if="success"
      :src="AlertImages.success"
      alt="alert"
    >
    <template v-else>
      <img
        v-if="voucher.Image !== null"
        :src="voucher.Image"
        alt="Voucher"
        class="logo my-5"
        style="max-width: 30vh;max-height: 30vh"
      >
      <h5>
        {{ voucher.Description ? voucher.Description : voucher.DescriptionArticle }}
      </h5>
    </template>

    <div class="ma-3">
      <v-btn
        color="success"
        block
        x-large
        style="height: 74px !important;"
        @click="toScan"
      >
        {{ $t(success ? 'field.voucher.scan' : 'field.voucher.submit') }}
      </v-btn>
    </div>

    <div class="pull-bottom bloc mb-5 px-5">
      <v-btn
        color="error"
        block
        outlined
        @click="toHome"
      >
        {{ $t(success ? 'button.back' : 'words.cancel') }}
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { AlertImages } from '@/modules/Images'
import { ActionEnum, IconEnum } from '@/modules/Enums'
import { Scan } from '@/modules/Scan'
import { $alert, createReference } from '@/modules/Utils'

export default {
  name: 'VoucherView',

  props: {
    idBadge: { type: String, default: null },
    voucher: { type: Object, default: () => {} },
    pme: { type: Object, default: () => {} },
    carrier: { type: Object, default: null }
  },

  data () {
    return {
      AlertImages,
      IconEnum,
      ticket: null,
      success: false
    }
  },

  methods: {
    toScan () {
      if (this.success) {
        this.$router.replace({
          name: 'scan-qrcode',
          params: { action: ActionEnum.voucher, backToHome: true }
        })
      } else {
        // Scan.launchVoucherConso(
        //   this.idBadge,
        //   this.voucher.IDVch,
        //   this.voucher.Nb,
        //   () => { this.success = true },
        //   (error) => { $alert(error) }
        // )
        Scan.launchDebit(
          this.idBadge,
          'P',
          this.idBadge,
          this.pme.Solde,
          () => { this.success = true },
          (error) => { $alert(error) },
          true,
          null,
          this.pme.Solde,
          false,
          createReference()
        )
      }
    },
    toHome () {
      this.$router.replace('/home')
    }
  }
}
</script>
